import { AnalyticsParamsWithPagination, getOnmStream } from '@/network/api/keyword'
import { useInfiniteQuery } from 'react-query'

export const useInfiniteOnmStream = (initParams: Omit<AnalyticsParamsWithPagination, 'page'>) => {
  return useInfiniteQuery(
    ['keywordOnmStream', initParams],
    ({ pageParam = 1 }) => {
      const params = {
        ...initParams,
        page: pageParam,
      }
      return getOnmStream(params)
    },
    {
      getNextPageParam: (lastPage) => {
        if (lastPage.payload?.data?.page >= lastPage.payload?.data?.totalPages) return undefined
        return lastPage.payload?.data?.page + 1
      },
    },
  )
}
